import { NoddiLogo } from 'noddi-ui-web';
import bestDriveLogo from '../assets/images/bestDrive.png';
import tronderdekkLogo from '../assets/images/trønderDekkLogoWhiteSpace.png';
import CarglassLogo from '../assets/svg/hurtigRuta';
import { useCurrentTheme } from '../stores/themeStore';

interface ThemeLogoProps {
  noddiColor?: string;
}

export function ThemeLogo({ noddiColor }: ThemeLogoProps) {
  const currentTheme = useCurrentTheme();

  function getLogo() {
    switch (currentTheme) {
      case 'default':
        return <NoddiLogo color={noddiColor} width={67} height={19} />;
      case 'bestdrive':
        return (
          <div className='rounded-md bg-black p-1'>
            <img src={bestDriveLogo} alt='brand logo' className='w-[82px]' />
          </div>
        );
      case 'tronderdekk':
        return <img src={tronderdekkLogo} alt='brand logo' className='w-[82px]' />;
      case 'carglass':
        return <CarglassLogo scale={0.8} />;
      default:
        return null;
    }
  }

  return <>{getLogo()}</>;
}
